/**
 * purchase-limit.js
 * custom.purchase_limit メタフィールドに設定された上限数を超えるカート追加を防ぐ。
 * 制限は商品単位（全バリアントの合計）で判定する。
 *
 * 【設計の要点】
 * - async関数内で await の後に preventDefault() を呼んでも効果がない（イベントの
 *   同期的な伝播はすでに終わっているため）。
 * - そのため、まず同期的に必ず止めてから非同期チェックを行い、
 *   制限内であれば WeakSet フラグを使って再発火する。
 * - 表示テキストは window.themeVariables.strings 経由でロケールファイルから取得する。
 */

(function () {
  console.log('[PL] スクリプト初期化完了');

  const allowedForms = new WeakSet();

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;
      console.log('[PL] submitイベント検知 action:', form.action, 'id:', form.id);

      if (!form.matches('[action*="/cart/add"]')) {
        console.log('[PL] cart/add フォームではないためスキップ');
        return;
      }

      if (allowedForms.has(form)) {
        allowedForms.delete(form);
        return;
      }

      const productFormEl = form.closest('product-form');
      if (!productFormEl) return;

      const purchaseLimit = parseInt(productFormEl.dataset.purchaseLimit, 10);
      console.log('[PL] purchaseLimit:', purchaseLimit, '| raw:', productFormEl.dataset.purchaseLimit);
      if (!purchaseLimit || isNaN(purchaseLimit)) {
        console.log('[PL] purchaseLimit が取得できないためスキップ');
        return;
      }

      // await より前に同期的に止める
      event.preventDefault();
      event.stopImmediatePropagation();

      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) {
        console.log('[PL] variantIdInput が見つからないため通過');
        _allow(form);
        return;
      }
      const variantId = parseInt(variantIdInput.value, 10);

      const quantityInput = form.elements['quantity'] || form.querySelector('input[name="quantity"]');
      const requestedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      console.log('[PL] variantId:', variantId, '| requestedQuantity:', requestedQuantity);

      // カート内の同商品（全バリアント合計）の現在数量を取得
      let currentQuantity = 0;
      try {
        // 1. data-product-id 属性から取得
        let productId = parseInt(productFormEl.dataset.productId, 10);
        console.log('[PL] productId (data属性):', productId, '| raw:', productFormEl.dataset.productId);

        // 2. 属性が取れない場合：商品ページURLから /products/{handle}.js を取得
        var productFetchPromise = Promise.resolve(null);
        if (!productId || isNaN(productId)) {
          var pathMatch = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
          if (pathMatch) {
            productFetchPromise = fetch('/products/' + pathMatch[1] + '.js')
              .then(function (r) { return r.json(); })
              .catch(function () { return null; });
          }
        }

        const results = await Promise.all([
          fetch('/cart.js').then(function (r) { return r.json(); }),
          productFetchPromise
        ]);
        const cart = results[0];
        const productData = results[1];

        if ((!productId || isNaN(productId)) && productData) {
          productId = productData.id;
          console.log('[PL] productId (URLフォールバック):', productId);
        }

        // 3. それでも取れない場合：カート内の同バリアントから product_id を推定
        if (!productId || isNaN(productId)) {
          var cartItem = cart.items.find(function (i) { return i.variant_id === variantId; });
          if (cartItem) productId = cartItem.product_id;
          console.log('[PL] productId (カートフォールバック):', productId);
        }

        console.log('[PL] カートアイテム:', cart.items.map(function(i){ return {product_id: i.product_id, variant_id: i.variant_id, quantity: i.quantity}; }));

        cart.items.forEach(function (item) {
          if (productId && !isNaN(productId)) {
            if (item.product_id === productId) currentQuantity += item.quantity;
          } else {
            if (item.variant_id === variantId) currentQuantity += item.quantity;
          }
        });

        console.log('[PL] currentQuantity:', currentQuantity, '| productId:', productId);
      } catch (e) {
        console.log('[PL] カート取得エラー:', e);
        _allow(form);
        return;
      }

      console.log('[PL] 判定: currentQuantity(' + currentQuantity + ') + requestedQuantity(' + requestedQuantity + ') > purchaseLimit(' + purchaseLimit + ') =', (currentQuantity + requestedQuantity > purchaseLimit));

      if (currentQuantity + requestedQuantity > purchaseLimit) {
        const remaining = purchaseLimit - currentQuantity;
        const strings = (window.themeVariables || {}).strings || {};

        let message;
        if (remaining <= 0) {
          message = (strings.purchaseLimitReached || '')
            .replace('{{ limit }}', purchaseLimit);
        } else {
          message = (strings.purchaseLimitWithRemaining || '')
            .replace('{{ limit }}', purchaseLimit)
            .replace('{{ remaining }}', remaining);
        }

        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: message }
          })
        );
      } else {
        _allow(form);
      }
    },
    true
  );

  function _allow(form) {
    allowedForms.add(form);
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
})();
